import { useTranslation } from 'react-i18next';
import { mainSiteUrl } from '@/mocks/categories';

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative flex min-h-[640px] items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20bright%20fresh%20flat%20lay%20of%20assorted%20fashion%20accessories%20including%20a%20straw%20hat%20woven%20tote%20bag%20sunglasses%20and%20linen%20scarf%20arranged%20on%20a%20warm%20cream%20linen%20background%20with%20soft%20sage%20and%20terracotta%20accents%2C%20gentle%20morning%20light%2C%20airy%20negative%20space%2C%20modern%20editorial%20lifestyle%20product%20photography%20with%20soft%20shadows%20and%20a%20clean%20spring%20aesthetic&width=1600&height=900&seq=hero-usfans-01&orientation=landscape&nocache=true"
          alt="USFans Spreadsheet resources and product guides"
          title="USFans Spreadsheet resources"
          className="h-full w-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/50"></div>

      <div className="relative z-10 mx-auto w-full max-w-4xl px-4 md:px-6 py-24 text-center">
        <div className="animate-fade-up">
          <span className="inline-flex items-center gap-2 rounded-full bg-background-50/15 px-4 py-1.5 text-sm font-medium text-background-50 backdrop-blur">
            <i className="ri-sparkling-line text-accent-300"></i>
            {t('heroTrust')}
          </span>
        </div>

        <h1 className="animate-fade-up animate-delay-1 mt-6 text-3xl font-bold leading-tight text-background-50 md:text-5xl font-heading">
          {t('heroTitle')}
        </h1>

        <p className="animate-fade-up animate-delay-2 mx-auto mt-5 max-w-2xl text-base leading-relaxed text-background-100 md:text-lg">
          {t('heroSubtitle')}
        </p>

        <div className="animate-fade-up animate-delay-3 mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex w-full items-center justify-center gap-2 rounded-md bg-primary-500 px-6 py-3 text-base font-semibold text-background-50 hover:bg-primary-600 whitespace-nowrap cursor-pointer sm:w-auto"
          >
            <i className="ri-leaf-line"></i>
            {t('usfansSpreadsheet')}
          </a>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex w-full items-center justify-center gap-2 rounded-md bg-accent-500 px-6 py-3 text-base font-semibold text-background-50 hover:bg-accent-600 whitespace-nowrap cursor-pointer sm:w-auto"
          >
            <i className="ri-shopping-cart-line"></i>
            {t('buyNow')}
          </a>
        </div>
      </div>
    </section>
  );
}